import { ga } from 'js/analytics/adapters'

type Glp1CtaSource = 'hero' | 'floating' | 'article'

interface TrackGlp1CtaClickParams {
  source: Glp1CtaSource
  articleSlug?: string
}

export function trackGlp1CtaClick({
  source,
  articleSlug,
}: TrackGlp1CtaClickParams) {
  ga.track('glp1_cta_click', {
    hitType: 'event',
    eventCategory: 'GLP-1',
    eventLabel: source,
    ...(articleSlug && { articleSlug }),
  })
}
